import Config from '../config/config'
import { BitlyClient } from 'bitly'
const bitlyConfig = { domain: 'l.the-cabin.com' }
const bitly = new BitlyClient(Config.bitlyAccessToken, bitlyConfig)

export default async function shorten(url) {
  let result
  try {
    result = await bitly.shorten(url)
  } catch (e) {
    throw e
  }
  return result
}



// WEBPACK FOOTER //
// ./src/apis/bitly.js